module.exports = __webpack_public_path__ + "img/hdd.d82118db.svg";